module.exports = __webpack_public_path__ + "static/img/215.42baf143.png";